
export default {
    label: 'Asukohad',
    name: 'locations',
    file: 'src/content/components/location.json',
    format: 'json',
    i18n: true,
    create: false,
    fields: [
        {
            label : 'Contact Title',
            name : 'contact_title',
            widget : 'string',
            i18n : true,
        },
        {
            label : 'Address Title',
            name : 'address_title',
            widget : 'string',
            i18n : true,
        },
        {
            label : 'Opening Hours Title',
            name : 'opening_hours_title',
            widget : 'string',
            i18n : true,
        },
        {
            label: 'Locations',
            name: 'locations',
            widget: 'list',
            i18n: true,
            types: [
                {
                    label: 'Location',
                    name: 'location',
                    widget: 'object',
                    fields: [
                        {
                            label: 'Name',
                            name: 'name',
                            widget: 'string',
                            default: '',
                            i18n: true,
                        },
                        {
                            label : 'Address',
                            name : 'address',
                            widget : 'text',
                            i18n : 'duplicate',
                        },
                        {
                            label: 'Opening Hours',
                            name: 'opening_hours',
                            widget: 'list',
                            default: '',
                            i18n: true,
                            fields: [
                                {
                                    label: 'Range',
                                    name: 'range',
                                    widget: 'string',
                                    default: '',
                                    i18n: true,
                                },
                                {
                                    label: 'Hours',
                                    name: 'hours',
                                    widget: 'string',
                                    default: '',
                                    i18n: 'duplicate',
                                },
                            ],
                        },
                        {
                            label: 'Phone',
                            name: 'phone',
                            widget: 'string',
                            default: '',
                            i18n: true,
                        },
                        {
                            label: 'Email',
                            name: 'email',
                            widget: 'string',
                            default: '',
                            i18n: true,
                        },
                        {
                            label : 'About',
                            name : 'about',
                            widget : 'text',
                            i18n : true,
                        
                        },
                        {
                            label: 'Map',
                            name: 'map',
                            widget: 'object',
                            fields: [
                                {
                                    label: 'Center Latitude',
                                    name: 'latitude',
                                    widget: 'string',
                                    i18n: true,
                                    required: true,
                                },
                                {
                                    label: 'Center Longitude',
                                    name: 'longitude',
                                    widget: 'string',
                                    i18n: true,
                                    required: true,
                                },
                                {
                                    label: 'Zoom',
                                    name: 'zoom',
                                    widget: 'string',
                                    i18n: true,
                                    required: true,
                                },
                                {
                                    label: 'Marker',
                                    name: 'marker',
                                    widget: 'object',
                                    fields: [
                                        {
                                            label: 'Latitude',
                                            name: 'latitude',
                                            widget: 'string',
                                            i18n: true,
                                            required: true,
                                        },
                                        {
                                            label: 'Longitude',
                                            name: 'longitude',
                                            widget: 'string',
                                            i18n: true,
                                            required: true,
                                        }
                                    ],
                                }
                            ],
                        }
                    ],
                }
            ],
        },
    ],
};